import { render, staticRenderFns } from "./DialogSync.vue?vue&type=template&id=19a5a3b9"
import script from "./DialogSync.vue?vue&type=script&lang=js"
export * from "./DialogSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports